
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Row } from 'react-bootstrap-3-legacy';
import { Link } from 'react-router-dom';
import axios from 'axios';
class introIntTest extends Component {
	constructor(props) {
		super(props)
		this.state = {
			testsInfo: ''
		}
	}

	componentDidMount() {
		console.log(this.props.auth)
		axios.post(`/api/intApi/getIntTests/`)
			.then(response => {
				this.setState({ testsInfo: response.data })
			})
			.catch(err => {
				console.log(err)
			})
	}

	render() {
		const info = this.state.testsInfo;
		let testOneDone = info.intI === 'Ne' ?
			(<Link to="/introIntTestOne" className="btn btn-info btn-fill col-md-12" >Test jedan </Link>)
			:
			(<Link to="/introIntTestOne" disabled className="btn btn-danger btn-fill col-md-12" >Test jedan </Link>)
		let testTwoDone = info.intII === 'Ne' ?
			(<Link to="/introIntTestTwo" className="btn btn-info btn-fill col-md-12" >Test dva </Link>)
			:
			(<Link to="/introIntTestTwo" disabled className="btn btn-danger btn-fill col-md-12" >Test dva </Link>)
		let testThreeDone = info.intIII === 'Ne' ?
			(<Link to="/introIntTestThree" className="btn btn-info btn-fill col-md-12" >Test tri </Link>)
			:
			(<Link to="/introIntTestThree" disabled className="btn btn-danger btn-fill col-md-12" >Test tri </Link>)

		return (
			<div className="Content">
				<div style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "inherit",
					padding: "3px"
				}}>
					<div style={{
						width: "80%",
						height: "80%",
						background: "#fff",
						boxShadow: "15px 15px 25px #ccc",
						borderRadius: "15px"
					}}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br /><br />
								Zdravo {this.props.auth.user.name},
								<br />
								<br />
								Pred Vama se nalazi test sposobnosti. Ovom testu možete pristupiti samo jednom
								<br />
								<br />
								Ukoliko se iz nekih nepredviđenih razloga (zatvaranje stranice, izlazak iz pretraživača, osvežavanje stranice testa) 
								izlogujete sa testa, javite se na e-mail adresu: {this.props.auth.user.company === "Group" ? "tanja.petrovic@galeb.com" : "jovana.markovic@galeb.com"}.
								<br />
								<br />
								Test se sastoji iz tri dela. Sva tri dela su vremenski ograničena:
								<br />
								prvi deo testa ograničen je na 4 minuta,
								<br />
								drugi deo na 2 minuta,
								<br />
								a poslednji deo testa na 8 minuta.
								<br />
								Pre svakog dela testa biće Vam detaljno objašnjeno na koji način se test rešava, imaćete primer i zadatke za vežbu.
								<br /><br />
								Srećno
								<br /><br />
								<Row className='justify-content-center'>
									<div className='col-md-2'>
										{testOneDone}
									</div>
									<div className='col-md-2' />
									<div className='col-md-2'>
										{testTwoDone}
									</div>
									<div className='col-md-2' />
									<div className='col-md-2'>
										{testThreeDone}
									</div>
								</Row>
							</div>
						</div>
					</div>
				</div>
			</div >
		)
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
});

export default connect(
	mapStateToProps,
)(introIntTest);